/* eslint-disable camelcase */

export interface Entitlement {
  /** Whether the entitlement is enabled */
  enabled: boolean;

  /** The entitlement key */
  key: EntitlementKey;

  /** The entitlement meta data */
  meta: {
    /** The date the entitlement expires - if any - in ISO 8601 format */
    expires_at: string | null;

    /** The reason the entitlement is enabled or disabled */
    internal_reason: string[];
  };
}

export interface EntitlementsResponse {
  /** List of Entitlements */
  entitlements: Record<EntitlementKey, Entitlement>;

  /** The ID of the Shop these entitlements relate to */
  merchant_id: number;
}

// TODO: See if we can generate these automatically as a post-install step
export const EntitlementKeys = {
  ACQUISITION_CHECKOUT_VIEW: 'acquisition::checkout::view',
  // TODO(embedded-forms): Change to 'acquisition::embedded_forms::view' when implemented
  ACQUISITION_EMBEDDED_FORMS_VIEW: 'acquisition::landing_pages::view',
  ACQUISITION_KEYWORDS_VIEW: 'acquisition::keywords::view',
  ACQUISITION_LIST_GROWTH_VIEW: 'acquisition::list_growth::view',
  ACQUISITION_POPUPS_VIEW: 'acquisition::popups::view',
  ACQUISITION_LANDING_PAGES_VIEW: 'acquisition::landing_pages::view',
  AI_ACTIVATION_VIEW: 'ai::activation::view',
  AI_BRAND_CENTER_VIEW: 'ai::brand_center::view',
  AI_SHOPPER_ENROLL: 'ai::shopper::enroll',
  ANALYTICS_MESSAGES_VIEW: 'analytics::messages::view',
  ANALYTICS_REPORTS_VIEW: 'analytics::reports::view',
  ANALYTICS_SUBSCRIBERS_VIEW: 'analytics::subscribers::view',
  ANALYTICS_TRENDS_VIEW: 'analytics::trends::view',
  FB_ACTIONS_CORE: 'fb::actions::core',
  FB_ACTIONS_EXTENDED: 'fb::actions::extended',
  FB_ADVANCED_CAMPAIGNS_USE: 'fb::campaigns::advanced::use',
  FB_ADVANCED_AUTOMATIONS_USE: 'fb::automations::advanced::use',
  FB_AUTOMATION_TABS_VIEW: 'fb::tabs::automation::view',
  FB_CAMPAIGNS_CONVERT: 'fb::campaigns::convert',
  FB_CAMPAIGNS_STANDARD_USE: 'fb::campaigns::standard::use',
  FB_CAMPAIGNS_TABS_VIEW: 'fb::tabs::campaign::view',
  FB_EVENTS_TRIGGER_AUTOMATION_CORE: 'fb::events::trigger::automation::core',
  FB_EVENTS_TRIGGER_AUTOMATION_EXTENDED:
    'fb::events::trigger::automation::extended',
  FB_EVENTS_CANCEL_AUTOMATION_CORE: 'fb::events::cancel::automation::core',
  FB_EVENTS_CANCEL_AUTOMATION_EXTENDED:
    'fb::events::cancel::automation::extended',
  FB_FILTERS_PROFILE_CORE: 'fb::filters::profile::core',
  FB_FILTERS_PROFILE_EXTENDED: 'fb::filters::profile::extended',
  FB_MERGE_TAGS_CORE: 'fb::merge_tags::core',
  FB_MERGE_TAGS_EXTENDED: 'fb::merge_tags::extended',
  FB_PROFILES_READ: 'fb::profiles::read',
  FB_SEGMENTS_USE_MANY: 'fb::segments::use_many',
  FB_STANDARD_AUTOMATIONS_USE: 'fb::automations::standard::use',
  FB_TEMPLATES_AUTOMATION_CORE: 'fb::templates::automation::core',
  FB_TEMPLATES_AUTOMATION_EXTENDED: 'fb::templates::automation::extended',
  FB_TEMPLATES_CAMPAIGN_CORE: 'fb::templates::campaign::core',
  FB_TEMPLATES_CAMPAIGN_EXTENDED: 'fb::templates::campaign::extended',
  FONDUE_SERVICE_VIEW: 'offers::fondue::view',
  INTEGRATIONS_BROWSE: 'integrations::browse',
  INTEGRATIONS_FONDUE_SETUP: 'integrations::fondue::setup',
} as const;

const ENTITLEMENT_KEYS = Object.values(EntitlementKeys);

export type EntitlementKey = typeof ENTITLEMENT_KEYS[number];

export { ENTITLEMENT_KEYS };
